<template>
    <v-row>
      <v-dialog v-model="showDialog" scrollable max-width="1050px" min-height="400px">
        <v-skeleton-loader
        v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>
        <v-card v-if="!loading">
          <v-card-title style="padding: 10px 0 0 10px; height: 20px;">
            <v-col cols="12">
                          <span style="font-size: 20px;">
                              {{ !data.id ? 'Nuevo módulo' : 'Editar módulo' }}
                          </span>
            </v-col>
          </v-card-title>
          <v-card-text style="padding-bottom: 0;"  @wheel="onWheel">
            <v-container>
                          <v-form ref="form">
  
                              <!--<v-tabs v-model="tab" v-if="!loading" style="margin-top: 20px;">
                                  <v-tab href="#dg">Datos generales</v-tab>
                                  <v-tab href="#fields">Columnas</v-tab>
                                  <v-tab href="#search">Filtros</v-tab>
                                  <v-tab href="#gmenu">Acciones</v-tab>
                                  <v-tab href="#cmenu">Menú contextual</v-tab>
                                  <v-tab href="#events">Eventos</v-tab>
                                  <v-tab href="#query">Consulta</v-tab>
                                    </v-tabs>

                                    <v-tabs-items  v-if="!loading" v-model="tab">
                                          <v-tab-item eager value="dg">
                                             
                                                <v-row style="margin-top: 20px;">

                                                      <v-col cols="6">                
                                                         <v-text-field
                                                               v-model="data.title"
                                                               :label="'Título'"
                                                               autocomplete="none"
                                                               :rules="[validationRules.required]"
                                                               :hint="$t(data.title)" persistent-hint
                                                               max="200"
                                                         />
                                                      </v-col>

                                                      <v-col cols="6">                
                                                         <v-text-field
                                                               v-model="data.description"
                                                               :label="'Descripción'"
                                                               autocomplete="none"
                                                               :rules="[validationRules.required]"
                                                               :hint="$t(data.description)" persistent-hint
                                                               max="300"
                                                         />
                                                      </v-col>
                     
                                                      <v-col cols="12">
                                                         <v-select
                                                               chips
                                                               multiple
                                                               v-model="rolesAllowed"
                                                               :items="roles"
                                                               menu-props="bottom, offsetY"
                                                               :label="$t('wkt.admin.report-types.edit-report-type.roles_allowed')"
                                                         />
                                                      </v-col>

                                                      <v-col cols="6">                
                                                         <v-text-field
                                                               v-model="data.companyId"
                                                               :label="'Empresa'"
                                                               autocomplete="none"
                                                               max="200"
                                                         />
                                                      </v-col>

                                                      <v-col cols="6">                
                                                         <v-text-field
                                                               v-model="data.employeeIds"
                                                               :label="'Trabajadores'"
                                                               autocomplete="none"
                                                               max="300"
                                                         />
                                                      </v-col>

                                                      <v-col cols="6" class="pb-0">  
                                                         <v-switch
                                                               v-model="data.fields.showGlobalFilter"
                                                               flat
                                                               label="Mostrar filtro global"
                                                            ></v-switch>
                                                      </v-col>

                                                </v-row>
                                          </v-tab-item>
                                          <v-tab-item eager value="fields">
                                             <v-row>
                                                <v-col cols="12">   
                                                   <ColumnEditor :columns="data.fields.headers"></ColumnEditor> 
                                                </v-col>
                                             </v-row>
                                          </v-tab-item>

                                          <v-tab-item eager value="search">
                                             <v-row>
                                                <v-col cols="12">   
                                                   <FilterEditor :filters="data.fields.search"></FilterEditor> 
                                                </v-col>
                                             </v-row>
                                          </v-tab-item>

                                          <v-tab-item eager value="gmenu">
                                             <v-row>
                                                <v-col cols="12">   
                                                   <MenuEditor :options="data.fields.menu"></MenuEditor> 
                                                </v-col>
                                             </v-row>
                                          </v-tab-item>

                                          <v-tab-item eager value="cmenu">
                                             <v-row style="margin-top: 20px;">

                                                <v-col cols="12">   
                                                   <MenuEditor :options="data.fields.rowMenu"></MenuEditor> 
                                                </v-col>
                                             </v-row>
                                          </v-tab-item>

                                          <v-tab-item eager value="events">
                                             <v-row>
                                                <v-col cols="12" class="pb-0">  
                                                   <v-switch
                                                         v-model="enableRowSelectEvent"
                                                         flat
                                                         label="Row Select Event"
                                                      ></v-switch>
                                                </v-col>
                                                <v-col cols="12" v-if="enableRowSelectEvent" class="pt-0">   
                                                   <EventEditor ref="selectRowEventEditor" :option="data.fields.onRowSelect" class="py-0"></EventEditor> 
                                                </v-col>
                                                <v-col cols="12" class="pb-0">  
                                                   <v-switch
                                                         v-model="enableAddItemEvent"
                                                         flat
                                                         label="Add Item Event"
                                                      ></v-switch>
                                                </v-col>
                                                <v-col cols="12" v-if="enableAddItemEvent" class="pt-0">   
                                                   <EventEditor ref="addItemEventEditor" :option="data.fields.onAddItem" class="py-0"></EventEditor> 
                                                </v-col>
                                             </v-row>
                                          </v-tab-item>

                                          <v-tab-item value="query" eager>
                                             <v-row style="margin-top: 20px;">
                                                <v-col cols="12">                
                                                   <v-textarea
                                                         v-model="data.source"
                                                         :label="'Consulta'" 
                                                         autocomplete="none"  auto-grow counter
                                                         :rules="[validationRules.required]"
                                                   />
                                                </v-col>
                                             </v-row>
                                          </v-tab-item>
                                    </v-tabs-items>-->

                           
                          </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <!--<v-btn v-if="data.id" color="#ff0000" @click="confirmDelete()">
                          <v-icon left color="#ffffff">delete</v-icon>
                          <span style="color: #ffffff;">{{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}</span>
                      </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>-->
            <v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
          <ConfirmDialog ref="dlgConfirm"
              v-bind:title="$t('wkt.admin.report-types.edit-report-type.confirm-dialog.title')"
              v-bind:message="$t('wkt.admin.report-types.edit-report-type.confirm-dialog.text')"
              v-bind:titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
              v-bind:titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
              v-on:confirmed="deleteItem()"
          />
    </v-row>	
  </template>
  
<script>
import BaseModule from '../../common/BaseModule.js'
import ConfirmDialog from '../../common/ConfirmDialog'
import api from '../../../api/worktime'

export default {
   name: 'ModuleDialog',
   mixins: [BaseModule],
   components: {
      ConfirmDialog
   },
   data() {
      return {
         showDialog: false,
         loading: true,
         rolesAllowed: [],
         data: {},
         fields: {},
         enableAddItemEvent: null,
         enableRowSelectEvent: null
      }
   },
   methods: {
      /*validateJSON: function (item) {
         if (!item) {
            return true;
         }

         try {
            JSON.parse(item);
         } catch (e) {
            return e.message;
         }

         return true;
      },*/
      // eslint-disable-next-line no-unused-vars
      open: function (action, payload) {
         /*this.showDialog = true;
         this.roles = Constants.roles;

         if (this.$refs.form) {
            this.$refs.form.resetValidation();
         }*/

         if (!payload) {
            this.data = {
               enabled: 1,
            };
            this.data.fields = {
               menu:[],
               rowMenu:[],
               search:[],
               headers:[]
            };
            this.rolesAllowed = [];
            this.loading = false; 
            return;
         }

         this.data = {
            id: parseInt(payload)
         };

         if (action === 'CSV') {
            this.downloadCSV();
            return;
         }

         if (action === 'LINK') {
            this.copyLinkDownloadCSV();
            return;
         }

         if (action === 'DELETE') {
            this.confirmDelete();
            //deleteItem();
            return;
         }

         /*this.loading = true;
         api.getModule(payload, res => {
            this.data = res;
            this.rolesAllowed = [];
            if (this.data.rolesAllowed) { // pasamos de lista separado por comas a array
               this.rolesAllowed = this.data.rolesAllowed.split(",").map(function (item) {
                  return item.trim();
               });
            }

            if (this.data.fields) { 
               this.data.fields = JSON.parse(this.data.fields);
               this.fields = {
                  headers: JSON.stringify(this.data.fields.headers,null,4),
                  search: JSON.stringify(this.data.fields.search,null,4),
                  rowMenu: JSON.stringify(this.data.fields.rowMenu,null,4),
                  menu: JSON.stringify(this.data.fields.menu,null,4),
                  onRowSelect: JSON.stringify(this.data.fields.onRowSelect,null,4),
                  onAddItem: JSON.stringify(this.data.fields.onAddItem,null,4)
               }
            } else {
               this.fields = {};
            }

            if (!this.data.fields.menu) {
               this.data.fields.menu = [];
            }

            if (!this.data.fields.rowMenu) {
               this.data.fields.rowMenu = [];
            }

            if (!this.data.fields.headers) {
               this.data.fields.headers = [];
            }

            if (!this.data.fields.search) {
               this.data.fields.search = [];
            }

            this.enableRowSelectEvent = !!this.data.fields.onRowSelect;
            this.enableAddItemEvent = !!this.data.fields.onAddItem;

            //En caso de estar duplicando, eliminamos el id para forzar un nuevo registro
            if (action === 'DUPLICATE') {
               this.data.id = undefined;
            }

            this.loading = false;
         }, error => {
            this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            this.loading = false;
         })*/
      },
      onSave: function () {
         /*if (!this.$refs.form.validate()) {
            return;
         }

         if (this.rolesAllowed.length > 0) {
            this.data.rolesAllowed = this.rolesAllowed.join();
         } else {
            this.data.rolesAllowed = null;
         }
 
         let fields = {
                  headers: this.data.fields.headers,
                  search: this.data.fields.search,
                  rowMenu: this.data.fields.rowMenu,
                  menu: this.data.fields.menu,
                  showGlobalFilter: this.data.fields.showGlobalFilter,
                  onRowSelect: this.enableRowSelectEvent?this.$refs.selectRowEventEditor.getValue():undefined,
                  onAddItem: this.enableAddItemEvent?this.$refs.addItemEventEditor.getValue():undefined
               }

         this.data.fields = JSON.stringify(fields);
         this.loading = true;
         // eslint-disable-next-line no-unused-vars
         api.storeModule(this.data,res => {
               this.loading = false;
               this.showDialog = false;
               this.$emit('refresh');
            },
            error => {
               this.$log.error(error);
               this.loading = false;
               this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            });*/
      },
      downloadCSV() {
         this.loading = true;
         // eslint-disable-next-line no-unused-vars
         api.downloadExportCSV(this.data.id, res => {
            this.loading = false;
         },
         error => {
            this.$log.error(error);
            this.loading = false;
            this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
         });
      },
      copyLinkDownloadCSV() {
         this.loading = true;
         // eslint-disable-next-line no-unused-vars
         api.getLinkDownloadExportCSV(this.data.id, res => {
            this.loading = false;            
            this.copyToClipboard(res);
            this.$emit('show-alert',{ text: 'Enlace copiado al portapapeles', color: 'success', timeout: 3000 });
         },
         error => {
            this.$log.error(error);
            this.loading = false;
            this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
         });
      },
      copyToClipboard(text) {
         var element = document.createElement("textarea");
         element.value = text;
         
         // avoid scrolling to bottom
         element.style.top = '0';
         element.style.left = '0';
         element.style.position = 'fixed';

         document.body.appendChild(element);
         element.focus();
         element.select();

         document.execCommand('copy');

         setTimeout(function(){
            document.body.removeChild(element);
         }, 1000);
      },
      confirmDelete() {
         this.$refs.dlgConfirm.confirm(this.data);
      },
      onWheel(event) {
         event.stopPropagation()
      },
      deleteItem() {
        this.loading = true;
        // eslint-disable-next-line no-unused-vars
         api.deleteExport(this.data.id, res => {
               this.showDialog = false;
               this.loading = false;
               this.$emit('refresh');
            },
            (error) => {
               this.loading = false;
               this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            }
         );
      }
   },
}
</script>